import React from 'react';
import CascaderDropdownLists from '../CascaderDropdownLists';
import BasicPopover from '../BasicPopover';
import ConfigConsumer from '../ConfigConsumer';
import { getValue } from '../tools/util';

var defaultOptionRender = function defaultOptionRender(_ref, _ref2) {
  var label = _ref.label,
      disabled = _ref.disabled,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;

  var setOpen = _ref2.setOpen;
  return {
    disabled: disabled,
    onClick: function onClick(e) {
      if (!disabled) {
        _onClick(e);

        setOpen(false);
      }
    },
    children: label
  };
};

export default function BasicDropdown(context, props) {
  var open = context.open,
      setOpen = context.setOpen,
      state = context.state,
      update = context.update;

  var children = props.children,
      data = props.data,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
      dropdown = props.dropdown,
      _props$optionRender = props.optionRender,
      _optionRender = _props$optionRender === void 0 ? defaultOptionRender : _props$optionRender,
      childrenName = props.childrenName;

  var _BasicPopover = BasicPopover({
    setOpen: setOpen,
    open: open
  }, {
    trigger: trigger
  }),
      exclusive = _BasicPopover.exclusive,
      popoverProps = _BasicPopover.popoverProps,
      onUpdate = _BasicPopover.onUpdate;

  return {
    onUpdate: onUpdate,
    exclusive: exclusive,
    popoverProps: popoverProps,
    children: children,
    dropdown: dropdown ? getValue(dropdown, context, props) : /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref3) {
      var configSize = _ref3.size;
      var minWidth = {
        large: 110,
        small: 70,
        mini: 70
      }[configSize] || 110;
      return /*#__PURE__*/React.createElement(CascaderDropdownLists, {
        childrenName: childrenName,
        state: state,
        update: update,
        data: data,
        optionRender: function optionRender(item) {
          return _optionRender(item, context);
        },
        dropdownListProps: {
          maxHeight: 216,
          minWidth: minWidth
        }
      });
    })
  };
}